/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
const INITIAL_CONTEXT = {
  idle: {},
  RESUBMIT_APPLICATION_SUCCESS: {
    message: 'Application resubmitted successfully',
  },
  RESUBMIT_APPLICATION_ERROR: {
    message: 'Failed to resubmit application',
  },
};

const MACHINE_CONFIG = {
  id: 'io.vlinder.jamaica.newApplication',
  initial: 'idle',
  context: INITIAL_CONTEXT,
  states: {
    idle: {
      entry: ['resetAction'],
      on: {
        MUTATE: { target: 'INITIATE_RESUBMIT_APPLICATION' },
      },
    },
    INITIATE_RESUBMIT_APPLICATION: {
      invoke: {
        id: 'ResubmitApp',
        src: 'ResubmitApp',
        onDone: {
          target: 'RESUBMIT_APPLICATION_SUCCESS',
          actions: ['successAction'],
        },
        onError: {
          target: 'RESUBMIT_APPLICATION_ERROR',
          actions: ['failureAction'],
        },
      },
    },
    RESUBMIT_APPLICATION_SUCCESS: {
      //type: "final",
      on: {
        MUTATE: { target: 'INITIATE_RESUBMIT_APPLICATION' },
      },
    },
    RESUBMIT_APPLICATION_ERROR: {
      //type: "final",
      on: {
        MUTATE: { target: 'INITIATE_RESUBMIT_APPLICATION' },
      },
    },
  },
};

//Machine(MACHINE_CONFIG)

export { INITIAL_CONTEXT, MACHINE_CONFIG };
